import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  parentList: [],
};

const parentSlice = createSlice({
  name: 'parent',
  initialState,
  reducers: {
    setParentList: (state, action) => {
      state.parentList = action.payload.list;
    }
  },
});

export const {
  setParentList,
} = parentSlice.actions;

export default parentSlice.reducer;